module.exports = __webpack_public_path__ + "static/pershing-5a9f94a19f3385a19402bbe64f601656.png";